import React, { useReducer } from 'react';
import { Modal } from 'rsuite';
import { CreatedPartner } from '../../../api/partner/partnerApiTypes';
import PartnerCreateForm from './Form/PartnerCreateForm';
import PartnerCreatedToken from './PartnerCreatedToken';
import { Status, initialState, reducer } from './partnerCreateState';

const TITLES_BY_STATUS: Record<Status, string> = {
  idle: 'Create new partner',
  creating: 'Create new partner',
  created: 'Partner created',
};

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onCreated: () => void;
}

export default function PartnerCreate({ isOpen, onClose, onCreated }: Props): JSX.Element {
  const [state, dispatch] = useReducer(reducer, initialState);

  function handleCreated(createdPartner: CreatedPartner) {
    dispatch({ type: 'partner/created', payload: createdPartner });
    onCreated();
  }

  function handleCreatingChange(isCreating: boolean) {
    dispatch({ type: 'creating/set', payload: isCreating });
  }

  function handleClose() {
    dispatch({ type: 'state/reset' });
    onClose();
  }

  function renderBody() {
    if (state.status === 'created') {
      return (
        <PartnerCreatedToken
          createdPartner={state.createdPartner}
          onDone={() => handleClose()}
        />
      );
    }

    return (
      <PartnerCreateForm
        onCancel={() => handleClose()}
        onCreated={(createdPartner) => handleCreated(createdPartner)}
        onCreatingChange={(isCreating) => handleCreatingChange(isCreating)}
      />
    );
  }

  return (
    <Modal
      open={isOpen}
      onClose={() => handleClose()}
      keyboard={state.status === 'idle'}
      backdrop="static"
      overflow
    >
      <Modal.Header closeButton={false}>
        <Modal.Title>
          {TITLES_BY_STATUS[state.status]}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isOpen && renderBody()}
      </Modal.Body>
    </Modal>
  );
}
